import React from 'react';
import { useSelector } from 'react-redux';
import ParticipantsGridShowMore from '../ParticipantsGridShowMore';
import ParticipantsGridItem from '../ParticipantsGridItem';
import { VISIBLE_PARTICIPANTS_COUNT } from '../../../../constants';
import { selectors as callSelectors } from '../../../../../call';
import { isDoctor } from '../../../../../call/helpers';
import './ParticipantsGridContent.scss';
const ParticipantsGridContent = ({ participants, selfParticipant, }) => {
    const activeStreamId = useSelector(callSelectors.getCurrentStreamId);
    const pinnedStreamId = useSelector(callSelectors.getPinnedStreamId);
    const isProvider = isDoctor();
    const hasShowMore = participants.length > VISIBLE_PARTICIPANTS_COUNT;
    const showMoreCounter = hasShowMore
        ? participants.length - VISIBLE_PARTICIPANTS_COUNT + 1
        : participants.length - VISIBLE_PARTICIPANTS_COUNT;
    return (<div className="ml-pg-list">
      <div className="ml-pg-list__item">
        {selfParticipant ? (<ParticipantsGridItem participant={selfParticipant} activeStreamId={activeStreamId} pinnedStreamId={pinnedStreamId} isSelfParticipant={true} isProvider={isProvider}/>) : null}
      </div>
      {participants.map((participant, index) => (<div style={{ order: index }} className="ml-pg-list__item" key={participant.id}>
          <ParticipantsGridItem participant={participant} activeStreamId={activeStreamId} pinnedStreamId={pinnedStreamId} isSelfParticipant={false} isProvider={isProvider}/>
        </div>))}
      {hasShowMore ? (<div className="ml-pg-list__item ml-pg-list__item--show-more">
          <ParticipantsGridShowMore amount={showMoreCounter}/>
        </div>) : null}
    </div>);
};
export default ParticipantsGridContent;
